import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor() { }

  /**
   * Muestra un diálogo de confirmación
   */
  confirm(message: string, header?: string, icon?: string): Observable<boolean> {
    const result = window.confirm(message);
    return of(result);
  }

  /**
   * Muestra un mensaje de información
   */
  showMessage(severity: string, summary: string, detail: string): void {
    console.log(`[${severity.toUpperCase()}] ${summary}: ${detail}`);
  }

  /**
   * Muestra un mensaje de error
   */
  showError(message: string, detail?: string): void {
    console.error(`ERROR: ${message}`, detail);
  }

  /**
   * Muestra un mensaje de éxito
   */
  showSuccess(message: string, detail?: string): void {
    console.log(`SUCCESS: ${message}`, detail);
  }
}

